import { cx } from "@suse-o11y/class-variance";
import { mergeRefs } from "@suse-o11y/merge-refs";
import React from "react";

import { RelativeContainerContextProvider } from "./_relative-container-context";

export type RelativeContainerProps = React.PropsWithChildren<React.ComponentProps<"div">>;

export const RelativeContainer = React.forwardRef<HTMLDivElement, RelativeContainerProps>(
	({ className, ...props }, ref) => {
		const [element, setElement] = React.useState<null | HTMLDivElement>(null);

		return (
			<RelativeContainerContextProvider value={element}>
				<div ref={mergeRefs([ref, setElement])} {...props} className={cx("relative", className)} />
			</RelativeContainerContextProvider>
		);
	},
);
